// import {
//   FETCH_BRANCH_FAILURE,
//   FETCH_BRANCH_REQUEST,
//   FETCH_BRANCH_SUCCESS,
// } from "./branchActionTypes";

// const initialState = {
//   branchData: [],
//   loading: false,
//   error: null,
// };

// const branchReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_BRANCH_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };
//     case FETCH_BRANCH_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         error: null,
//         branchData: action.payload.data,
//       };
//     case FETCH_BRANCH_FAILURE:
//       return {
//         ...state,
//         branchData:[],
//         loading: false,
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

// export default branchReducer;

import {
  FETCH_BRANCH_REQUEST,
  FETCH_BRANCH_SUCCESS,
  FETCH_BRANCH_FAILURE,
  CREATE_BRANCH_REQUEST,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAILURE,
  UPDATE_BRANCH_REQUEST,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAILURE,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAILURE,
} from "./branchActionTypes";

const initialState = {
  branchData: [],
  loading: false,
  error: null,
};

const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case FETCH_BRANCH_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        branchData: action.payload.data,
      };
    case FETCH_BRANCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        branchData: [],
      };

    // CREATE
    case CREATE_BRANCH_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        branchData: action.payload.data,
      };
    case CREATE_BRANCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case UPDATE_BRANCH_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        branchData: action.payload.data,
      };
    case UPDATE_BRANCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case DELETE_BRANCH_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        branchData: action.payload.data,
      };
    case DELETE_BRANCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default branchReducer;
